import { gql } from "@apollo/client";

export const MODIFY_NOTE = gql`
  mutation modifyNote($noteInput: NoteInput) {
    modifyNote(noteInput: $noteInput) {
      note {
        uuid
      }
      successMessage
    }
  }
`;

export const CREATE_PATIENT_NOTE = gql`
  mutation createPatientNote(
    $noteInput: NoteInput
    $recordingConsentEventUuid: UUID
  ) {
    createPatientNote(
      noteInput: $noteInput
      recordingConsentEventUuid: $recordingConsentEventUuid
    ) {
      note {
        uuid
      }
      successMessage
    }
  }
`;

export const CREATE_QUICK_NOTE = gql`
  mutation createQuickNote(
    $noteInput: NoteInput
    $recordingConsentEventUuid: UUID
  ) {
    createQuickNote(
      noteInput: $noteInput
      recordingConsentEventUuid: $recordingConsentEventUuid
    ) {
      note {
        uuid
      }
      successMessage
    }
  }
`;

export const CREATE_INVENTORY = gql`
  mutation createInventory($storageObjectName: String!) {
    createInventory(storageObjectName: $storageObjectName) {
      ok
    }
  }
`;

export const APPEND_RECORDING = gql`
  mutation appendRecording(
    $noteUuid: String
    $storageObjectName: String
    $createdAt: DateTime
    $lastUpdatedAt: DateTime
  ) {
    appendRecording(
      noteUuid: $noteUuid
      storageObjectName: $storageObjectName
      createdAt: $createdAt
      lastUpdatedAt: $lastUpdatedAt
    ) {
      ok
    }
  }
`;

export const DELETE_NOTE = gql`
  mutation deleteNote($noteUuid: String) {
    deleteNote(noteUuid: $noteUuid) {
      ok
    }
  }
`;

export const DELETE_NOTES = gql`
  mutation deleteNotes($noteUuids: [String]) {
    deleteNotes(noteUuids: $noteUuids) {
      ok
    }
  }
`;

export const DETACH_NOTES_FROM_PATIENT = gql`
  mutation detachNotesFromPatient($noteUuids: [String]) {
    detachNotesFromPatient(noteUuids: $noteUuids) {
      ok
      affectedCount
      affectedUuids
    }
  }
`;

export const UNGROUP_NOTE = gql`
  mutation UngroupNote($noteUuid: String!) {
    ungroupNote(noteUuid: $noteUuid) {
      ok
    }
  }
`;

export const CREATE_GROUPED_NOTES = gql`
  mutation CreateGroupedNotes(
    $storageObjectName: String!
    $templateGroupUuid: String!
    $patientUuid: String
    $title: String
    $recordingConsentEventUuid: UUID
  ) {
    createGroupedNotes(
      storageObjectName: $storageObjectName
      templateGroupUuid: $templateGroupUuid
      patientUuid: $patientUuid
      title: $title
      recordingConsentEventUuid: $recordingConsentEventUuid
    ) {
      ok
      noteGroup {
        uuid
      }
    }
  }
`;
